import React, { useContext } from 'react';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import PanelPopup from '../_partials/PanelPopup';
import DesktopLayout from '../_partials/DesktopLayout';
import MonetizationStrip from '../../MonetizationStrip';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import DesktopAdhesion from '@wix/da-ads/pkg/adunits/DesktopAdhesion';
import ErrorBoundary from '../../ErrorBoundary';
import { getCurrentAdSafety } from '../../Ads/redux/selectors';
import { useSelector } from 'react-redux';
import s from './DesktopDeviationPage.scss';
var DesktopDeviationPage = function (_a) {
    var deviation = _a.deviation;
    var adsNitro = useFlag('ads_nitro');
    var adsEnabled = useContext(SessionContext).adsEnabled;
    var adSafety = useSelector(function (state) { return getCurrentAdSafety(state); });
    return (React.createElement(DesktopLayout, { deviation: deviation, stageContent: React.createElement(React.Fragment, null,
            adsNitro && adsEnabled && (React.createElement(ErrorBoundary, { debugComponent: "DesktopAdhesion" },
                React.createElement(DesktopAdhesion, { safety: adSafety }))),
            React.createElement(ArtStage, { deviation: deviation }),
            React.createElement("div", { className: s['strip-tier-promotion-wrapper'] },
                React.createElement(MonetizationStrip, { className: s['strip-tier-promotion'], deviation: deviation })),
            React.createElement(ActionBar, { deviation: deviation }),
            React.createElement(PanelPopup, { deviation: deviation, actionBarType: "primary", className: s['large-popover-uplifted'] })), metaContent: React.createElement(React.Fragment, null,
            React.createElement(Details, { contentClassName: s['details'], deviation: deviation }),
            React.createElement(UserGiftSaleBanner, { user: deviation.author })), withSecondaryActionBar: [DeviationTypes.JOURNAL].includes(getDeviationType(deviation)) }));
};
DesktopDeviationPage.displayName = 'DesktopDeviationPage';
export default DesktopDeviationPage;
//# sourceMappingURL=DesktopDeviationPage.js.map